import { render } from "./FooterSection.vue?vue&type=template&id=5686f9ca&scoped=true"
import script from "./FooterSection.vue?vue&type=script&lang=js"
export * from "./FooterSection.vue?vue&type=script&lang=js"

import "./FooterSection.vue?vue&type=style&index=0&id=5686f9ca&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5686f9ca"]])

export default __exports__